import { ComponentType } from 'react';
import { Route } from 'services/route';

export async function runMiddleware(route: Route): Promise<boolean | ComponentType | string> {
  if (!route.middleware) return true;

  for (let i = 0; i < route.middleware.length; i++) {
    const shouldRunNext = await new route.middleware[i]().process(route.data || {});

    if (shouldRunNext === true) {
      continue;
    }

    return shouldRunNext;
  }

  return true;
}
